export default __webpack_public_path__ + "static/media/apple-store-badge.8c4986ee.svg";